<template>
  <v-data-table :items="produits" :headers="headers">
    <template v-slot:item.ajouter="{ item }">
      <v-btn color="primary" text @click="ADD_ITEM(item)" small>{{ $t("boutique.ajouterAuPanier") }}</v-btn>
    </template>
    <template v-slot:item.titre="{ item }">
      <router-link :to="{ name: 'Produit', params: { id: item.id }, query: { ...$route.query } }">
        <span>{{ item.titre }}</span>
      </router-link>
    </template>
    <template v-slot:item.prix="{ item }">
      {{ item.prix | money }}
    </template>
    <template v-slot:item.categorie="{ item }">
      {{ item.categorie[$i18n.locale] }}
    </template>
    <template v-slot:item.langue="{ item }">
      {{ item.langue[$i18n.locale] }}
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex"
export default {
  props: {
    produits: Array
  },
  methods: {
    ...mapActions(["ADD_ITEM"])
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("boutique.tableauProduits.titre"),
          value: "titre"
        },
        {
          text: this.$t("boutique.tableauProduits.categorie"),
          value: "categorie",
          sort: (a, b) => (a.id < b.id ? -1 : 1)
        },
        { text: this.$t("boutique.tableauProduits.langue"), value: "langue", sort: (a, b) => (a.id < b.id ? -1 : 1) },
        { text: this.$t("boutique.tableauProduits.prix"), value: "prix", align: "right" },
        { text: "", sortable: false, value: "ajouter" }
      ]
    }
  }
}
</script>

<style>
</style>